<div class="form-group mr-2">
  <div class="input-group d-flex justify-content-center align-items-strech">
    <div class="flex-grow-1">
      <p-date-picker
        [(ngModel)]="dateTime"
        [showTime]="true"
        [showIcon]="true"
        [hourFormat]="(useMilitaryTime$ | async) === false ? '12' : '24'"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [dateFormat]="'dd/mm/yy'"
        [styleClass]="'w-100'"
        size="small"
        panelStyleClass="my-datepicker-panel"
        (onSelect)="onDateTimeChange($event)"
      ></p-date-picker>
    </div>
  </div>
</div>
